import useSWR from 'swr';

export interface TrashItem {
  kind: 'artifact' | 'repo' | 'project';
  id: string;
  title: string;
  subtitle: string;
  project_id: string;
  project_slug: string;
  deleted_at: string;
  deleted_by: string;
  expires_at: string;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useTrash() {
  return useSWR<TrashItem[]>('/api/v1/trash', fetcher, { refreshInterval: 30_000 });
}

export async function restoreTrash(kind: 'artifact' | 'repo' | 'project', id: string): Promise<void> {
  const res = await fetch(`/api/v1/trash/${kind}/${id}/restore`, {
    method: 'POST', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw new Error(await res.text());
}

export async function purgeTrash(kind: 'artifact' | 'repo' | 'project', id: string): Promise<void> {
  const res = await fetch(`/api/v1/trash/${kind}/${id}`, {
    method: 'DELETE', credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw new Error(await res.text());
}
